const newPushPopover = require('../widgets/new-push-popover').default
const ReactDOM = require('react-dom')
const React = require('react')

const popoverWorkflowsEl = document.querySelector('.create-new-push-button')
if (popoverWorkflowsEl && popoverWorkflowsEl instanceof HTMLElement) {
  ReactDOM.render(
    React.createElement(newPushPopover, {
      hasPComposerAccess: popoverWorkflowsEl.hasAttribute(
        'data-has-pcomposer-access'
      ),
      hasExperimentsAccess: popoverWorkflowsEl.hasAttribute(
        'data-has-experiments'
      ),
      hasAppleNews: popoverWorkflowsEl.hasAttribute('data-has-apple-news'),
      hasAutomationSeries: popoverWorkflowsEl.hasAttribute(
        'data-has-automation-series'
      ),
      hasTriggersTag: popoverWorkflowsEl.hasAttribute('data-has-triggers-tag'),
      hasInAppAutomation: popoverWorkflowsEl.hasAttribute(
        'data-has-in-app-automation'
      ),
      createMessageUrl: popoverWorkflowsEl.getAttribute(
        'data-create-message-url'
      ),
      createExperimentUrl: popoverWorkflowsEl.getAttribute(
        'data-create-experiment-url'
      ),
      createAppleNewsUrl: popoverWorkflowsEl.getAttribute(
        'data-create-apple-news-url'
      ),
      createAutomatedUrl: popoverWorkflowsEl.getAttribute(
        'data-create-automated-url'
      ),
      createAutomationSeriesUrl: popoverWorkflowsEl.getAttribute(
        'data-create-automation-series-url'
      ),
      createZoltarUrl: popoverWorkflowsEl.getAttribute('data-create-zoltar-url')
    }),
    popoverWorkflowsEl
  )
}
